type Callback = (...args: unknown[]) => void;

/**
 * Simple event bus.
 */
class Event {
  private readonly events: { [key: string]: Callback[] };
  constructor() {
    this.events = {};
  }

  on(eventName: string, fn: Callback) {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(fn);
  }

  once(eventName: string, fn: Callback) {
    this.events[eventName] = this.events[eventName] || [];
    const onceCallback: Callback = (...args) => {
      this.off(eventName, onceCallback);
      fn(...args);
    };
    this.events[eventName].push(onceCallback);
  }

  off(eventName: string, fn: Callback) {
    if (this.events[eventName]) {
      for (let i = 0; i < this.events[eventName].length; i++) {
        if (this.events[eventName][i] === fn) {
          this.events[eventName].splice(i, 1);
          break;
        }
      }
    }
  }

  emit(eventName: string, data: unknown) {
    if (this.events[eventName]) {
      this.events[eventName].forEach(function (fn: Callback) {
        fn(data);
      });
    }
  }
}

export default new Event();
